import { useEffect, useState } from 'react';

import { useAuthContext } from '../Auth/context';
import * as api from './api';

const useAPI = (props = {}) => {
  const { callback } = props;
  const [status, setStatus] = useState('initial');
  const [countries, setCountries] = useState([]);
  const [error, setError] = useState();
  const [errors, setErrors] = useState({});

  const { state: { jwt }, actions: { updateAuth } } = useAuthContext();

  const getUser = async (bookingId) => {
  };

  const updateAccount = async (payload) => {
    setStatus('submitting');

    try {
      const { data } = await api.updateAccount(payload, { jwt });
      setStatus('ready');
      if (data.success && data.user) {
        updateAuth({ user: data.user });
        if (typeof callback === 'function') callback();
      } else {
        if (data.validationErrors) setErrors(data.validationErrors);
      }
    } catch (error) {
      setError('فشل في تحديث المستخدم');
    }
  };

  const requestPasswordReset = async (email) => {
    setStatus('submitting');

    try {
      const { data } = await api.requestPasswordReset(email, { jwt });

      setStatus('ready');
      setError(null);

      if (data.success) setStatus('submitted');
      else {
        setError('فشل في تأكيد  البريد الاإلكتروني');
      }
    } catch (error) {
      setStatus('ready');

      const { data: errorCode } = error.response || {};
      let message = errorCode === 'ACCOUNT_NOT_FOUND'
        ? 'لا يوجد حساب لهذا البريد الاإلكتروني'
        : 'فشل في تأكيد  البريد الاإلكتروني';
      if (error.networkError) message = 'الرجاء التأكد من صلاحية الإتصال بالإنترنت';

      setError(message);
    }
  };

  const submitPasswordReset = async (email) => {
    setStatus('submitting');

    try {
      const { data } = await api.submitPasswordReset(email, { jwt });

      setStatus('ready');
      setError(null);

      if (data.success) {
        setStatus('submitted');
        if (typeof callback === 'function') callback();
      } else {
        setError('فشل في تأكيد  البريد الاإلكتروني');
      }
    } catch (error) {
      setStatus('ready');

      const { data: errorCode } = error.response || {};
      let message = errorCode === 'ACCOUNT_NOT_FOUND'
        ? 'لا يوجد حساب لهذا البريد الاإلكتروني'
        : 'فشل في تأكيد  البريد الاإلكتروني';

      if (error.networkError) message = 'الرجاء التأكد من صلاحية الإتصال بالإنترنت';
      if (errorCode === 'EXPIRED_TOKEN') message = 'انتهت مدة صلاحية رابط تعديل كلمة المرور';
      if (errorCode === 'ALREADY_USED_TOKEN') message = 'تم إستخدام رابط التعديل مسبقا';

      setError(message);
    }
  };

  useEffect(() => {
    api.getCountries()
      .then(({ data }) => {
        setCountries(data.countries);
        setStatus('ready');
      }).catch(console.log);
  }, []);

  return {
    actions: { getUser, updateAccount, requestPasswordReset, submitPasswordReset },
    data: { countries },
    status,
    error,
    errors
  };
};

export default useAPI;
